import { render } from "./MasterClassEgitim.vue?vue&type=template&id=70d7b24a&scoped=true"
import script from "./MasterClassEgitim.vue?vue&type=script&lang=js"
export * from "./MasterClassEgitim.vue?vue&type=script&lang=js"

import "./MasterClassEgitim.vue?vue&type=style&index=0&id=70d7b24a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d7b24a"]])

export default __exports__